import {
  CountryCodes,
  DEFAULT_PAGE_SIZE,
  ListQueryParam,
  ListRange,
  SearchCriteriaBase,
  UliActivityType,
} from '../../../../../../../common';

export class TrailerHandlingCouplingPlanModel {
  trailerPlate: string;
  country: CountryCodes;
  carrier: string;
  loadNumber: string;
  truckId: number;
  webCouplingReadyUliDetailsView: {
    uli: string;
    type: UliActivityType;
  };

  constructor(params?: TrailerHandlingCouplingPlanModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface TrailerHandlingListURIParams {
  hubId: number;
  searchCriteria: CouplingPlanSearchCriteria;
}

export class CouplingPlanSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.LoadNumberFilter] = '';
  [ListQueryParam.TrailerPlateFilter] = '';
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;

  constructor(params?: CouplingPlanSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
